import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";
import { formatAmountByConfig } from "@/shared/utils/amountFormat";

export const stripDecimals = (val: string | number): string => {
  const num = Number(val);
  if (isNaN(num)) return String(val);
  return Math.floor(num).toString();
};

export const formatValueOrCross = (value: any): string => {
  const invalidValues = ["None", "false", "Not Covered", "-", "", "0.0"];

  //  invalid cases
  if (
    value === null ||
    value === undefined ||
    value === false ||
    value === 0 ||
    invalidValues.includes(value)
  ) {
    return "❌";
  }

  // ✅ number OR numeric string
  const isNumeric =
    (typeof value === "number" && !isNaN(value)) ||
    (typeof value === "string" && /^[+-]?\d+(\.\d+)?$/.test(value.trim()));

  return isNumeric
    ? stripDecimals(
        formatAmountByConfig(Number(value), {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          fallback: "0",
        })
      )
    : String(value);
};

export const callUploadFileApi = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await axiosInstance.post(App_Url_New.ApiEndPoint.documentUpload, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};
